import React from "react";
import SlidingCarousel from "../SlidingCarousel/SlidingCarousel";

import CppWhiteBoardContents from "./CppWhiteBoardContents";
import FilterString from "./FilterString";

// By extending the React.Component class, TextArea inherits functionality from it
class CppWhiteBoard extends React.Component 
{

    constructor(props)
    {

    	/* We MUST call the parent class contructor and send it the props object */
    	super(props);

	    // Setting the initial state of the TextArea component
	    this.state = 
	    {
	        contents: this.props.value
	    };

	} // End of constructor()
	
	switchScreens = (screenIndex) =>
	{
		console.log("in switchScreens, screenIndex is " + screenIndex);
		this.refs.carousel.setActiveScreen(screenIndex);
	}
 
    
    // The render method returns the JSX that should be rendered
	render() 
	{
	    return (
	    	<div className="CppWhiteBoardMain">	
			<h1 className='text-center'>C / C++ White Board Exercises</h1>	
           
                <SlidingCarousel ref="carousel" name="WebLog"
                componentArray=
				{
					[
                        <CppWhiteBoardContents switcher={this.switchScreens} />,
                        <FilterString />
						
					]
				}/>

	    	</div>
	    )
    }
    
}; // End of class WebLog

export default CppWhiteBoard;


// WEBPACK FOOTER //
// ./src/components/CppWhiteBoard/CppWhiteBoard.js